import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const QUIZ_URL = process.env.REACT_APP_QUIZ_URL;

export const SQUARE_MONTHLY_URL = process.env.REACT_APP_SQUARE_MONTHLY_URL || "";
export const SQUARE_ANNUAL_URL = process.env.REACT_APP_SQUARE_ANNUAL_URL || "";

const COACH_KEY = "w2w_coach_ref";
export const setCoachRef = (code) => {
  try { if (code) localStorage.setItem(COACH_KEY, code.toLowerCase()); } catch { /* noop */ }
};
export const getCoachRef = () => {
  try { return localStorage.getItem(COACH_KEY) || ""; } catch { return ""; }
};

export const trackEvent = (event, meta = {}) => {
  try {
    axios.post(`${API}/events`, { event, meta });
  } catch {
    /* analytics must never break UX */
  }
};

export const formatApiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};
